import React, { FormEvent } from 'react';

export const Form: React.SFC<{ onSubmit: any }> = ({ onSubmit, children }) => {
  const handleSubmit = (event: FormEvent) => {
    event.preventDefault();
    onSubmit(event);
  };

  return <form onSubmit={handleSubmit}>{children}</form>;
};
